import * as React from "react";

function IconShareSocialOutline(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M176 256 A48 48 0 0 1 128 304 A48 48 0 0 1 80 256 A48 48 0 0 1 176 256 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M432 112 A48 48 0 0 1 384 160 A48 48 0 0 1 336 112 A48 48 0 0 1 432 112 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M432 400 A48 48 0 0 1 384 448 A48 48 0 0 1 336 400 A48 48 0 0 1 432 400 z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M169.83 279.53l172.34 96.94M342.17 135.53l-172.34 96.94"
      />
    </svg>
  );
}

export default IconShareSocialOutline;
